export default __webpack_public_path__ + "static/media/twitter.e0ed6ddf.svg";